import AsyncStorage from '@react-native-async-storage/async-storage';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Removes the CSRF token that older app versions kept in AsyncStorage.
 */
export async function removeLegacyCsrfToken() {
  try {
    await AsyncStorage.removeItem(LEGACY_CSRF_TOKEN_KEY);
  } catch {}
}

// ─── Constants ───────────────────────────────────────────────────────────────

const LEGACY_CSRF_TOKEN_KEY = 'csrf-token';
